import { skipToken, useQuery } from "@tanstack/react-query";

import { contentListQuery } from "../queries";
import { ContentListOptions } from "../service";

export function useContentList(
  options?: ContentListOptions,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const query = contentListQuery(options);
  return useQuery({ ...query, queryFn: enabled ? query.queryFn : skipToken });
}
